// function to show notifications
export const showNotification = (response, msg = null, indicateBgProcess = false) => {
  // Create a new div for the notification
  const notification = document.createElement("div");

  let iconCode, message, notificationClass;

  // show loading spinner if indicating background process
  if (indicateBgProcess) {
    iconCode =
      '<div class="loader" style="width: 12px; height: 12px; border: 2px solid rgba(70, 136, 71, 0.3); border-top: 2px solid #468847; display: inline-block; vertical-align: middle;"></div>';
    message = msg || "Processing...";
    notificationClass = "success";
  } else {
    iconCode = response ? "&#10003;" : "!";
    message = msg || (response ? "Configuration saved" : "Failed to save configuration");
    notificationClass = response ? "success" : "error";
  }

  notification.innerHTML = `<span class="notification-icon">${iconCode}</span> ${message}`;
  notification.classList.add("notification", notificationClass);

  // Append the notification to the body
  document.body.appendChild(notification);

  // remove the notification after  3 seconds
  setTimeout(() => {
    notification.remove();
  }, 3000);
};
